import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from '../Icon/Icon';

import css from './IconSpinner.module.css';

/**
 * A loading spinner: the set's `loading` icon, turning. Size and colour come from the class
 * (`rootClassName` replaces the default 28px primary-coloured one).
 */
const IconSpinner = props => {
  const { rootClassName, className } = props;
  return (
    <Icon
      name="loading"
      size={24}
      rootClassName={classNames(css.spin, rootClassName || css.root)}
      className={className}
    />
  );
};

IconSpinner.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

IconSpinner.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconSpinner;
